function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgT = function SvgT(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 85"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m41.5 84.5-23.1-.1.4-68-18.7-.6V0h62.2l-2.1 17.5-15.1-.4zm-40-71.1L4.2 1.3l-2.6-.2zm20 57 3.7-53.8-3.6-.2z",
    style: {
      fill: "#9da2d2"
    }
  }));
};
export default SvgT;